export const DialogContext = React.createContext(null);
export function useDialogContext() {
    const value = React.useContext(DialogContext);
    return value;
}
